var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-base',{attrs:{"action":_vm.logut,"icon":"box-arrow-left"}},[_vm._v(" ログアウト ")])}
var staticRenderFns = []

export { render, staticRenderFns }